import React from "react";
import { ShieldAlert, ShieldCheck, Shield, ShieldQuestion } from "lucide-react";
import { useTranslation } from "react-i18next";

const styles = {
  High: {
    bg: "bg-red-50",
    text: "text-red-800",
    border: "border-red-200",
    Icon: ShieldAlert,
    iconColor: "text-red-500",
  },
  Medium: {
    bg: "bg-amber-50",
    text: "text-amber-800",
    border: "border-amber-200",
    Icon: Shield,
    iconColor: "text-amber-500",
  },
  Low: {
    bg: "bg-emerald-50",
    text: "text-emerald-800",
    border: "border-emerald-200",
    Icon: ShieldCheck,
    iconColor: "text-emerald-500",
  },
  "N/A": {
    bg: "bg-zinc-50",
    text: "text-zinc-600",
    border: "border-zinc-200",
    Icon: ShieldQuestion,
    iconColor: "text-zinc-400",
  },
};

export default function RiskBadge({ level = "N/A", size = "md", testId }) {
  const { t } = useTranslation("common");
  const cfg = styles[level] || styles["N/A"];
  const { Icon } = cfg;
  const sizes = {
    sm: "text-xs px-2 py-0.5 gap-1",
    md: "text-xs px-2.5 py-1 gap-1.5",
    lg: "text-sm px-3 py-1.5 gap-2",
  };
  const iconSize = size === "lg" ? 16 : size === "sm" ? 12 : 14;
  const labelKey = level === "N/A" ? "risk.unknown" : `risk.${String(level).toLowerCase()}`;
  return (
    <span
      data-testid={testId}
      className={`inline-flex items-center rounded-full border font-medium ${cfg.bg} ${cfg.text} ${cfg.border} ${sizes[size]}`}
    >
      <Icon size={iconSize} strokeWidth={1.75} className={cfg.iconColor} />
      <span className="tracking-tight">{t(labelKey, `${level} risk`)}</span>
    </span>
  );
}
